export function getView(is_connecting, is_admin) {
  if (is_connecting) return 'Connecting'

  return is_admin ? 'Connect' : 'No'
}
